import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import CommError from '../../Shared/Errors/Errors'

import './CreateEditMenuGroup.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        paddingTop: '0px',
        background: 'white'
    }
}


let paragraphStyle = {
    backgroundColor: "white"
}

const CreateEditMenuGroup = (
    {
        errMenuGroup,
        errMenuGroupClear,
        locationMenuGroupTypes,
        curLocationMenuGroup,
        tmpLocationMenuGroup,
        viewMode,
        create,
        isOpen,
        valuesCheck,
        onAfterOpen,
        onRequestClose,
        onRequestCancel

    }) => (
    <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
            <CommError error={errMenuGroup.error} onClose={errMenuGroupClear} />

            <div className="create-edit-menu-group productManagement">
                {viewMode ?
                    <h1>Location Menu Group</h1>
                    : <h1>{create ? 'Edit' : 'Create'} Location Menu Group</h1>
                }

                <p style={paragraphStyle}>*= Required to Submit</p>
            <div>
                { create ? 
                    <div className="form-group">
                        <label>Location Menu Group ID: </label>
                            <span id="location_menu_group_id">{create ? curLocationMenuGroup.id : null}</span>
                    </div> : null
                }
                <div className="form-group">
                        <label htmlFor="location_menu_group_name">Group Name:*</label>
                        <input className="form-control" id="location_menu_group_name" disabled={viewMode ? true : false} onChange={valuesCheck} defaultValue={create ? curLocationMenuGroup.name : tmpLocationMenuGroup.name}/>
                </div>
                <div className="form-group">
                        <label htmlFor="location_menu_display_order">Display Order:</label>
                        <input className="form-control" id="location_menu_display_order" disabled={viewMode ? true : false} defaultValue={create ? curLocationMenuGroup.displayOrder : tmpLocationMenuGroup.displayOrder} />
                </div>
                <div className="form-group">
                        <label htmlFor="location_menu_group_type">Group Type:*</label>
                        <select id="location_menu_group_type" disabled={viewMode ? true : false} onChange={valuesCheck} defaultValue={create ? curLocationMenuGroup.locationGroupTypeId : tmpLocationMenuGroup.locationGroupTypeId} className="multibox supp form-control">
                            <option value="0">Select</option>
                            {
                                
                                locationMenuGroupTypes ? locationMenuGroupTypes.location_menu_group_types.map((locationGroupType, index) => {
                                    return <option value={locationGroupType.locationGroupTypeId} key={index}>
                                        {locationGroupType.locationGroupTypeName}
                                    </option>;
                                }) : null
                            }
                        </select>
                </div>
                <div className="form-group">
                        <label htmlFor="location_menu_group_status">Status:</label>
                        <select id="location_menu_group_status" disabled={viewMode ? true : false} defaultValue={ create? curLocationMenuGroup.isActive.toString() : tmpLocationMenuGroup.isActive.toString()} className="multibox supp form-control">
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                </div>
             
            </div>
            <div className="form-group">
                <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>&nbsp;
                <button className="btn btn-primary modbrick" create={create ? "false" : "true"} onClick={onRequestClose}>Submit</button>
            </div>
        </div>
    </Modal>
);

// Modal.setAppElement('body');
        
export default CreateEditMenuGroup